import React from "react";
import { Button, Col, Form, Row, Select } from "antd";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell,
} from "recharts";

import FilterContainer from "../../../../components/common/FilterContainer";
import { propertyList } from "../surveysData";

const Analysis = () => {
  const pieChartData = [
    { name: "Yes", value: 400 },
    { name: "No", value: 150 },
  ];
  const pieChart2Data = [
    { name: "Yes", value: 400 },
    { name: "No", value: 100 },
  ];

  const COLORS = ["rgb(141, 209, 225)", "rgb(164, 222, 108)"];


  const data = [
    {
      name: "Page A",
      rating: 4000,
      pv: 2400,
      amt: 2400,
    },
    {
      name: "Page B",
      rating: 3000,
      pv: 1398,
      amt: 2210,
    },
    {
      name: "Page C",
      rating: 2000,
      pv: 9800,
      amt: 2290,
    },
    {
      name: "Page D",
      rating: 2780,
      pv: 3908,
      amt: 2000,
    },
    {
      name: "Page E",
      rating: 1890,
      pv: 4800,
      amt: 2181,
    },
    {
      name: "Page F",
      rating: 2390,
      pv: 3800,
      amt: 2500,
    },
    {
      name: "Page G",
      rating: 3490,
      pv: 4300,
      amt: 2100,
    },
  ];

  return (
    <div>
      <Row>
        <Col span={24}>
          <FilterContainer heading="Filter surveys using the filter below:">
            <Form
              name="basic"
              labelCol={{ span: 6 }}
              wrapperCol={{ span: 16 }}
              initialValues={{ remember: true }}
              autoComplete="off"
              colon={false}
            >
              <Form.Item label="Property">
                <Select
                  showSearch
                  placeholder="Search by property, group, or portfolio"
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  options={propertyList}
                />
              </Form.Item>

              <Form.Item label=" ">
                <Button type="primary" htmlType="submit">
                  Search
                </Button>
              </Form.Item>
            </Form>
          </FilterContainer>
        </Col>
      </Row>

      <p>How satisfied are you with the overall experience?</p>
      <br />
      <ResponsiveContainer width="50%" height={300}>
        <LineChart
          width={500}
          height={200}
          data={data}
          margin={{
            top: 10,
            right: 30,
            left: 0,
            bottom: 0,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip />
          <Legend />
          <Line
            connectNulls
            type="monotone"
            dataKey="rating"
            stroke="#2ca5dc"
            fill="#2ca5dc"
          />
        </LineChart>
      </ResponsiveContainer>
      <br />
      <br />
      <Row justify='center'>
        <Col span={12}>
          <Row>
            <Col span={18} sty>
              <p style={{textAlign:'right'}}>Has the issue been resolved completely?</p>
              <br />
              <div style={{textAlign:'center',display:'flex',justifyContent:'center'}}>
                <p><span><i className="fa-solid fa-square" style={{color:'rgb(141, 209, 225)'}}></i> </span> Yes</p>
                <p style={{marginLeft:'20px'}}><span><i className="fa-solid fa-square" style={{color:'rgb(164, 222, 108)'}}></i> </span> No</p>
              </div>
            </Col>
          </Row>
          <Row>
            <Col span={18}>
              <PieChart width={560} height={250}>
                <Pie
                  data={pieChartData}
                  cx="50%"
                  cy="50%"
                  labelLine={false}
                  label={false}
                  outerRadius={80}
                  fill="#8884d8"
                  dataKey="value"
                >
                  {pieChartData.map((entry, index) => (
                    <Cell
                      key={`cell-${index}`}
                      fill={COLORS[index % COLORS.length]}
                    />
                  ))}
                </Pie>
              </PieChart>
            </Col>
          </Row>
        </Col>
      </Row>
      <br /><br />
      <Row justify='center'>
        <Col span={12}>
          <Row>
            <Col span={18} sty>
              <p style={{textAlign:'right'}}>Was the work completed in a timely manner?</p>
              <br />
              <div style={{textAlign:'center',display:'flex',justifyContent:'center'}}>
                <p><span><i className="fa-solid fa-square" style={{color:'rgb(141, 209, 225)'}}></i> </span> Yes</p>
                <p style={{marginLeft:'20px'}}><span><i className="fa-solid fa-square" style={{color:'rgb(164, 222, 108)'}}></i> </span> No</p>
              </div>
            </Col>
          </Row>
          <Row>
            <Col span={18}>
              <PieChart width={560} height={250}>
                <Pie
                  data={pieChart2Data}
                  cx="50%"
                  cy="50%"
                  labelLine={false}
                  label={false}
                  outerRadius={80}
                  fill="#8884d8"
                  dataKey="value"
                >
                  {pieChart2Data.map((entry, index) => (
                    <Cell
                      key={`cell-${index}`}
                      fill={COLORS[index % COLORS.length]}
                    />
                  ))}
                </Pie>
              </PieChart>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
};

export default Analysis;
